/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import type {
  CreateQuickViewApiArg,
  ReadInstrumentsApiArg,
  UpdateQuickViewApiArg,
  UpdateQuickViewPanelsApiArg,
} from 'lib-analytics-types';
import moment from 'moment-timezone';

import { i18n } from 'utils/i18n';

export function transformReadInstrumentsArg({
  id,
  ...body
}: ReadInstrumentsApiArg): Omit<ReadInstrumentsApiArg, 'id'> {
  return {
    ...body,
    settings: {
      ...body.settings,
      timezone: body.settings?.timezone ?? moment.tz.guess(),
      locale: i18n.getPreferredLocale(),
    },
    meta: Object.keys(body.meta ?? {}).length ? body.meta : undefined,
  };
}

export function transformCreateUpdateQuickViewArg(
  quickView:
    | CreateQuickViewApiArg['quickView']
    | UpdateQuickViewApiArg['quickView'],
) {
  return {
    ...quickView,
    panels:
      'panels' in quickView
        ? transformUpdateQuickViewPanelsArg(quickView.panels)
        : // The update endpoint cannot be used to update panels. We set it as an empty array here
          // because the backend requires it in the request payload, but it has no effect.
          [],
  };
}

/** Transform and include only backend-relevant fields in create/update requests. */
export function transformUpdateQuickViewPanelsArg(
  panels: UpdateQuickViewPanelsApiArg['panels'],
) {
  return panels.map(
    ({ id: panel_id, dashboard_id, description, layout, controls }) => ({
      panel_id,
      dashboard_id,
      layout,
      controls,
      description,
    }),
  );
}
